import { SalaryGroupTeacher, Teacher } from '@/plugins/api'

// need refactor
// count
async function countStudent() {
  let count = await Teacher.count({ _start: 0, _limit: -1, status: 'active' })
  return count
}
function countTeacherInLevel(levelId) {
  return Teacher.count({ academicLevels: levelId, status: 'active' })
}
async function countStudentInGroup(id) {
  let count = await SalaryGroupTeacher.count({ salary_group: id })
  return count
}

async function searchStudent(params) {
  let list = await Teacher.search({
    _start: params._start,
    _limit: params._limit,
    status: 'active'
  })
  return list
}
function searchTeacherInLevel(params, levelId) {
  return Teacher.search({
    _start: params._start,
    _limit: params._limit,
    academicLevels: levelId,
    status: 'active'
  })
}
async function searchStudentInGroup(id, params) {
  let list = await SalaryGroupTeacher.search({
    salary_group: id,
    _limit: params._limit,
    _start: params._start,
    _sort: 'nameToNumber:ASC'
  })
  let arr = list.map(function(element) {
    return {
      ...element.teacher,
      groupStudentId: element.id
    }
  })
  return arr
}

async function fetchStudent() {
  let fetch = await Teacher.fetch({ _start: 0, _limit: -1 })
  return fetch
}
function fetchTeachersByLevel(levelId) {
  return Teacher.fetch({ _start: 0, _limit: -1, academicLevels: levelId, status: 'active' })
}
async function fetchStudentInGroup(id) {
  let fetch = await SalaryGroupTeacher.fetch({ salary_group: id })
  let arr = fetch.map(function(element) {
    return {
      ...element.teacher,
      groupStudentId: element.id
    }
  })
  return arr
}

async function getListStudent({ group, params }) {
  console.log(group)
  if (group.defaultType === 'all') {
    let students = await searchStudent(params)
    return students
  } else if (group.defaultType === 'level') {
    const list = await searchTeacherInLevel(group.defaultId)
    return list
  } else {
    let students = await searchStudentInGroup(group.id, params)
    return students
  }
}

async function getTotalItemsStudent({ group }) {
  if (group.defaultType === 'all') {
    let totalItems = await countStudent()
    return totalItems
  } else if (group.defaultType === 'level') {
    const count = await countTeacherInLevel(group.defaultId)
    return count
  } else {
    let totalItems = await countStudentInGroup(group.id)
    return totalItems
  }
}

async function fetchTeachers({ group }) {
  console.log(group)
  if (group.defaultType === 'all') {
    let students = await fetchStudent()
    return students
  } else if (group.defaultType === 'level') {
    const teachers = await fetchTeachersByLevel(group.defaultId)
    return teachers
  } else {
    let students = await fetchStudentInGroup(group.id)
    return students
  }
}

async function getListGroup(tuitionFeeGroups) {
  let list = []
  for (let item of tuitionFeeGroups) {
    if (item.defaultType === 'all') {
      list.push({
        ...item,
        amount: await countStudent()
      })
    } else {
      list.push({
        ...item,
        amount: await countStudentInGroup(item._id)
      })
    }
  }
  return list
}

export { getListGroup, getListStudent, fetchTeachers, countStudentInGroup, getTotalItemsStudent }
